import React from 'react';
import { Button, Container, Reveal } from '@/components/ui';
import { resumeContent } from '@/content/resume';

/**
 * Hero section for the example résumé/portfolio product variant (§11 of
 * `docs/TEMPLATE_IMPROVEMENT_RECOMMENDATIONS.md`) — see `ResumeDemo.tsx`.
 */
const ResumeHero: React.FC = () => {
    const { profile } = resumeContent;

    return (
        <section id="resume-hero" className="resume-hero">
            <Container>
                <Reveal as="div">
                    <p className="resume-eyebrow">Portfolio</p>
                    <h1 className="resume-name">{profile.name}</h1>
                    <p className="resume-title">{profile.title}</p>
                    <p className="resume-summary">{profile.summary}</p>
                    <Button as="a" href="#resume-contact" variant="primary">
                        Get in touch
                    </Button>
                </Reveal>
            </Container>
        </section>
    );
};

export default ResumeHero;
